import React, { useState } from 'react'
import { Button, Progress, Spin } from 'antd'
import type { CompareRunPhase } from '../hooks/useCompareRun'
import styles from '../PlanManagementV3.module.scss'

function phaseTitle(phase: CompareRunPhase, stage: string | null): string {
  if (phase === 'starting' || phase === 'queued') return 'Starting compare…'
  return stage ? `${stage}…` : 'Comparing…'
}

/** Progress for a compare run — shared by both compare tabs. */
export function CompareRunProgress({
  phase,
  progress,
  stage,
  description,
  canCancel,
  onCancel,
}: {
  phase: CompareRunPhase
  progress: number
  stage: string | null
  description: string
  canCancel: boolean
  onCancel: () => Promise<void>
}) {
  const [isCancelling, setIsCancelling] = useState(false)

  const handleCancel = async () => {
    setIsCancelling(true)
    try {
      await onCancel()
    } finally {
      setIsCancelling(false)
    }
  }

  return (
    <div className={styles.ideonProgress}>
      <Spin size="large" className={styles.emptyStateSpinner} />
      <h2 className={styles.emptyStateCompactTitle}>
        {phaseTitle(phase, stage)}
      </h2>
      <p className={styles.emptyStateCompactDescription}>
        {phase === 'queued'
          ? 'Compares run one at a time — if another one is running, this one starts as soon as it finishes.'
          : description}
      </p>
      {phase !== 'starting' && (
        <Progress
          className={styles.ideonProgressBar}
          percent={progress}
          status="active"
          strokeColor="#01a0a8"
        />
      )}
      <Button
        danger
        className={styles.emptyStateCompactButton}
        loading={isCancelling}
        disabled={isCancelling || !canCancel}
        onClick={() => void handleCancel()}
      >
        Cancel
      </Button>
    </div>
  )
}
